import { render, staticRenderFns } from "./TrackAndTrace.vue?vue&type=template&id=3adfcc22&scoped=true&"
import script from "./TrackAndTrace.vue?vue&type=script&lang=js&"
export * from "./TrackAndTrace.vue?vue&type=script&lang=js&"
import style0 from "./TrackAndTrace.vue?vue&type=style&index=0&id=3adfcc22&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3adfcc22",
  null
  
)

export default component.exports